import React, { memo } from 'react';
import { Environment as DreiEnvironment } from '@react-three/drei';
import { useLevaControls } from './LevaControls';

const Lights = memo(() => {
const { Scene: { BackGround,Intensity } } = useLevaControls();


  return (
    <>
      <ambientLight intensity={2} color={"#060a7e"} />
      <DreiEnvironment preset={"warehouse"} environmentIntensity={Intensity}/>
      <fog attach="fog" args={[BackGround, 0.1, 45]} />
    </>
  );
});

export default Lights;
